<template>
  <div
    ref="embedContainer"
    class="w-full flex justify-center items-center"
    :class="classes"
  >
    <div v-if="loading" class="mt-24">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div ref="pdfHolder" class="pdf-holder"></div>
  </div>
</template>

<script>
import { ref, watchEffect } from 'vue'

export default {
  name: 'embed-document',
  props: {
    docSource: {
      type: String,
      required: true
    },
    classes: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const fetchingLocale = ref(true)
    const hasReplaced = ref(false)
    const loading = ref(true)

    const embedContainer = ref(null)
    const pdfHolder = ref(null)

    const fetchDoc = val => {
      let divContainer = embedContainer.value
      let pdfHolderEl = pdfHolder.value
      let url = val
      if (
        url.startsWith('https://docs.google.com/document/d/') ||
        url.startsWith('https://docs.google.com/spreadsheets/d')
      ) {
        let div = document.createElement('div')
        div.classList.add('embedded-doc')
        if (!hasReplaced.value) {
          divContainer.replaceChild(div, pdfHolderEl)
          hasReplaced.value = true
        } else {
          let childToReplace
          if (divContainer?.childNodes) {
            childToReplace = divContainer.childNodes[0]
          }
          divContainer.replaceChild(div, childToReplace)
        }
        var xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.onload = function () {
          loading.value = false
          let tempXHR = xhr.responseText.replaceAll(
            '<img',
            '<img referrerpolicy="no-referrer"'
          )
          div.innerHTML = tempXHR
        }
        xhr.send()
      }
    }

    watchEffect(() => {
      if (embedContainer.value && pdfHolder.value) {
        fetchDoc(props.docSource)
      }
    })

    return {
      fetchingLocale,
      hasReplaced,
      loading,
      embedContainer,
      pdfHolder
    }
  }
}
</script>

<style scoped lang="scss">
.embedded-doc {
  div {
    padding: 5px !important;
  }
}

img {
  max-width: 100vw !important;
}

:deep(.doc-content) {
  padding: 2rem !important;
  min-width: 360px !important;
  background-color: transparent !important;

  @media (max-width: 360px) {
    min-width: unset !important;
    max-width: 100vw !important;
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #007a33;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #007a33 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
